import Footer from "./Popup/Footer.es6";

/////////////////////////////////////////////////
//
// Manages the Popup Component on App
//
// Use & Require:
// pub/assets/js/interface/_mask.es6
// app/data/scss/components/_popup.scss
//
////////////////////////////////////////////////////////////
(() => {
    class Popup extends App.Component {
        constructor(container) {
            super(container);
            this.Footer     = new Footer(this);
            this.instances  = {};
            this
                .prepare()
                .bindAction()
            ;

            if (this.$.hasClass('show')) { this.showActiveInstance(); }

            /* GLOBALIZE */
            App.Components.wait(this.container, 'Instance', I => App.Components.Popup = I);
        }

        /* GETTERS */
        get instance() {
            return this.container.querySelector('[data-identifier="XMLHttpRequest"]');
        }
        /* SETTERS */
        set layout(layout) {
            this.instance.dataset.layout = layout;
        }
        /* GETTERS & SETTERS */
        get header() {
            return this.instance.querySelector('.popup-header');
        }
        set header(html) {
            this.header.innerHTML = html;
        }
        get body() {
            return this.instance.querySelector('.popup-main');
        }
        set body(html) {
            // Use jQuery to run inline scripts coming from the view
            // Please check for alternative way of running inline JS if jQuery is replaced
            $(this.body).html(html);
        }

        get isVisible() {
            return this.$.hasClass('show');
        }

        // Hide Popup
        hide(force = false) {
            return new Promise(resolve => {
                // Only close popup is there i no other popup active
                if (this.$.find('.popup-instance.active').length && force !== true) {
                    this.$.find('.popup-instance:not(:only-child)').removeClass('show');
                    this.showActiveInstance();
                } else {
                    /* Timer to show hide transition */
                    const time = 100;
                    setTimeout(() => {
                        App.Interface.Mask.hide();
                        setTimeout(() => {
                            this.$.find('.popup-instance').removeClass('show');
                            this.instance.classList.remove('show');
                            this.container.classList.remove('show');
                            this.reset();
                            this.removeStash();
                            resolve();
                        }, App.Setting('FX_DURATION_SHORT') - time);
                    }, time);
                }
            });
        }

        reset() {
            this.layout = 'default';
            this.resetFooter();
        }

        removeStash() {
            this.$.remove('[data-identifier="stash"]');
        }

        // Show Popup
        show() {
            this.$.addClass('show');
            App.Interface.Mask
                .fullscreen()
                .show()
            ;

            if (this.$.find('.popup-instance.show').hasClass('fixed')) {
                App.Interface.Mask.fixed();
            }
        }

        setPage(page = App.Entities.Page, anchor = '') {
            App.Layout.setFMPResources(page, 'popup').then(() => {
                $(this.instance).find('.popup-header').html();
                this.setTitle(page.title);
                this.body = page.content;
                this.instance.classList.add('show');
                if (anchor) {
                    this.instance.dataset.popupAnchor = `#${anchor}`;
                } else {
                    this.instance.dataset.popupAnchor = '';
                }
                this.layout = page.overlayLayout;
                /* Footer */
                this.Footer.render(page);

                App.Layout.setFCPResources(page, 'popup').then(() => {
                    App.Interface.Mask.preloader(false);

                    // Popup will close if is empty
                    if (page.content !== '') {
                        const identifier = 'XMLHttpRequest';
                        this.showInstance(identifier);

                        setTimeout(() => {
                            this.scrollPopupContent(identifier);
                        }, 250);
                    } else {
                        this.hide();
                    }
                    this.update();
                });
            }).catch(() => {
                App.Interface.Mask.preloader(false);
                this.body = 'Could not load page :(';
                this.showInstance('XMLHttpRequest');
            });
            return this;
        }

        setTitle(title) {
            this.header = title;
            return this;
        }

        showActiveInstance() {
            this.showInstance(this.container.querySelector('.popup-instance.active').dataset.identifier);
            return this;
        }

        hasInstance(identifier) {
            if (this.instances[identifier] !== undefined) return true;
        }

        getInstance(identifier) {
            return this.instances[identifier];
        }

        showInstance(identifier) {
            this.$.children('.show').removeClass('show').addClass('active');
            let element = this.$.find('[data-identifier="' + identifier + '"]').last();
            element
                .addClass('show')
                .removeClass('active')
            ;
            this.scrollPopupContent(identifier);
            if (identifier === 'stash') {
                $(this.instance).remove();
                element.attr('data-identifier', 'XMLHttpRequest');
            }
            this.show();
            return this;
        }

        scrollPopupContent(identifier) {
            let element = this.container.querySelector('[data-identifier="' + identifier + '"]');
            let main    = $(element).find('.popup-main');
            let target  = main.find(element.dataset.popupAnchor);
            if (element.dataset.popupAnchor && target.length) {
                main.scrollTop(0);
                let position = target.offset().top - main.offset().top;
                main.scrollTop(position);
            } else {
                main.scrollTop(0);
            }
        }

        prepare() {
            let instance = this;
            this.$.find('.popup-instance').each(function() {
                let element = $(this);
                instance.instances[element.data('identifier')] = element;
            });
            return this;
        }

        bindAction() {

            App.Layout.onNormalize(() => this.hide());

            this.body.addEventListener("scroll", e => {
                if (e.target.scrollTop <= -100) {
                    this.hide(true);
                }
            });
            this.bindCloseAction();
            this.bindRefreshAction();
            this.bindTriggerAction();

            return this;
        }

        bindTriggerAction() {
            let instance = this;

            /* Bind element for XMLHttp requests */
            App.Layout.html.on('click', 'a[target="popup"]', e => {
                e.preventDefault();
                let element = $(e.target);

                // Stash popup to go back to
                if (e.target.rel !== 'nofollow' && element.parents('.popup').length) this.stashInstance();
                this.resetXMLHttpRequestContent();

                if (element.attr('href')) {
                    this.showXMLHttpRequestContent(element.attr('href'));
                } else {
                    throw new Error('Trying to load xhr content, no "href" attribute or XMLHttpRequest container found');
                }
            });

            /* Link element for XMLHttp requests */
            App.Layout.html.on('submit', 'form[target="popup"]', function(e) {

                e.preventDefault();
                let element = $(this);

                if (element.attr('action')) {
                    App.Page.post(element.attr('action'), element.serialize()).then(Page => instance.setPage(Page));
                } else {
                    throw new Error('Trying to load xhr content, no "href" attribute or XMLHttpRequest container found');
                }
            });

            /* Show instance */
            App.Layout.html.on('click', '[data-popup]', function(e) {
                e.preventDefault();
                const identifier = $(this).data('popup');
                instance.showInstance(identifier);
                this.scrollPopupContent(identifier);
            });

            /* Hide popup on masks click */
            App.Interface.Mask.onHide(function() {
                instance.hide(true);
            });
            return this;
        }

        async showXMLHttpRequestContent(url = false) {
            App.Interface.Mask.preloader(true).show();
            this.body = ''; // reset body to show preloader
            // Get url content if set
            let anchor = '';
            if (url) {
                anchor = url.split('#')[1];
            }
            return Promise.all([App.Page.get(url, 'popup')]).then(values => {
                const Page = values.shift();
                if (!Page) {
                    App.Interface.Mask.preloader(false);
                    return;
                }
                this.setPage(Page, anchor);
            }).catch((Page) => {
                this.setPage(Page.shift(), anchor);
            });
        }

        stashInstance() {
            const prev = this.instance.outerHTML;
            this.instance.classList.remove('show');
            this.instance.classList.add('active');
            this.instance.dataset.identifier = 'stash';
            this.$.append(prev);
        }

        resetFooter() {
            this.Footer.Buttons.container.innerHTML = this.Footer.Buttons.initial;
            return this;
        }

        resetXMLHttpRequestContent() {
            this.instance.querySelector('.popup-header').innerHTML = '';
            this.instance.querySelector('.popup-main').innerHTML = '';
            this.layout = 'default';
            return this;
        }

        bindCloseAction() {
            let instance = this;
            this.$.on('click', '.js-popup-close', function() {
                instance.hide();
            });
            return this;
        }

        bindRefreshAction() {
            let instance = this;
            this.$.find('.js-popup-refresh').click(function() {
                instance.prepare();
            });
            $(window).resize(function() {
                instance.prepare();
            });
            return this;
        }

        async update() {
            this.Observer.notify();
            App.Layout.refresh();
        }
    }
    // @todo: remove "main-element" when popup runs only over one main channel
    App.Components.register('div.popup.main-element', Popup);
})();
